

























































import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'
import confirm from 'components/modals/Confirm'
import TopicButtonAdd from 'src/components/presenter/item/forum/TopicButtonAdd.vue'
import TopicButtonTrashEmpty from 'src/components/presenter/item/forum/TopicButtonTrashEmpty.vue'
import TopicListItem from 'components/presenter/item/forum/TopicListItem.vue'
import api from 'src/assets/api/gql'
import ForumTopicsGetAll from 'src/graphql/forum/ForumTopicsGetAll.gql'
import { ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    TopicButtonAdd,
    TopicButtonTrashEmpty,
    TopicListItem
  }
})
export default class ItemForum extends Vue {
  loading = false
  topics: ForumTopic[] = []
  showDeleted = false

  get item () {
    return store.state.presenter.item
  }

  get topicsSorted () {
    const pinned = this.topics.filter(t => t.pinnedAt && !t.deletedAt).sort((a, b) => {
      return new Date(a.pinnedAt || 0).getTime() - new Date(b.pinnedAt || 0).getTime()
    })
    const regular = this.topics.filter(t => !t.pinnedAt && !t.deletedAt).sort((a, b) => {
      return new Date(b.lastPostAt || 0).getTime() - new Date(a.lastPostAt || 0).getTime()
    })
    return [...pinned, ...regular]
  }

  get topicsDeleted () {
    return this.topics.filter(t => t.deletedAt).sort((a, b) => {
      return new Date(b.deletedAt || 0).getTime() - new Date(a.deletedAt || 0).getTime()
    })
  }

  refresh (done: () => void) {
    this.topics = []
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    this.loading = true
    const { data: { forumTopics } } = await api.query({
      query: ForumTopicsGetAll,
      variables: { courseId: this.item.id }
    })
    if (forumTopics) {
      this.topics = forumTopics.nodes as ForumTopic[]
    }
    this.loading = false
    done(true)
  }

  async emptyTrash () {
    this.topics = this.topics.filter(t => !t.deletedAt)
  }
}
